import styles from './index.module.scss';
// import { useHistory } from 'react-router-dom';
import DocumentRight from '../../../../assets/svg/document-right.svg';
import DocumentRightHover from '../../../../assets/svg/document-right-hover.svg';

interface IProps {
  readonly title: string;
  readonly content: string;
  readonly url: string;
}

export const DocumentationCard = (props: IProps) => {
  // const history = useHistory();

  const goDocumentPage = () => {
    window.open(props.url, undefined);
    // history.push(props.url);
  };

  return (
    <div className={styles.documentationCard} onClick={goDocumentPage}>
      <div className={styles.documentationCardHeader}>
        <div className={styles.documentationCardTiele}>{props.title}</div>
        <div className={styles.documentationCardContent}>{props.content}</div>
      </div>
      <div>
        <img src={DocumentRight} className={styles.cardImg} />
        <img src={DocumentRightHover} className={styles.cardImgHover} />
      </div>
    </div>
  );
};
